'use strict';

var React = require('react');

var SvgTransactionFeeYenIcon = function SvgTransactionFeeYenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 3a2.25 2.25 0 1 0 1 4.266v3.984a2.75 2.75 0 0 0 2.75 2.75h.25a.75.75 0 0 0 0-1.5h-.25c-.69 0-1.25-.56-1.25-1.25v-5.25h2.878a2.251 2.251 0 1 0 0-1.5h-3.256a2.25 2.25 0 0 0-2.122-1.5Zm-.75 2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm7.5 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.994 9.186a.75.75 0 0 0-.988 1.128l1.744 1.526v.41h-1a.75.75 0 0 0 0 1.5h1v.5h-1a.75.75 0 0 0 0 1.5h1v.5a.75.75 0 0 0 1.5 0v-.5h1a.75.75 0 0 0 0-1.5h-1v-.5h1a.75.75 0 0 0 0-1.5h-1v-.41l1.744-1.526a.75.75 0 1 0-.988-1.128l-1.506 1.317-1.506-1.317Z"
  }));
};
SvgTransactionFeeYenIcon.displayName = "TransactionFeeYenIcon";

exports.SvgTransactionFeeYenIcon = SvgTransactionFeeYenIcon;
